module.exports = __webpack_public_path__ + "img/140019.408e83e7.png";